/// <amd-module name="Test/ManualTestReports/TestReportsCommon/Constants" />

export const TestResourceEntityNames = {
    Points: "TestPoints",
    Suites: "TestSuites",
    Configurations: "TestConfigurations",
    PointHistorySnapshot: "TestPointHistorySnapshot"
};

export const TestPointFieldNames = {
    PlanId: "TestPlanId",
    SuiteId: "TestSuite/IdLevel3",
    Outcome: "LastResultOutcome",
    ConfigurationId: "TestConfigurationId",
    Priority: "Priority",
    AssignedTo_UserSK: "AssignedTo/UserSK",
    AssignedTo_UserName: "AssignedTo/UserName",
    Tester_UserSK: "Tester/UserSK",
    Tester_UserName: "Tester/UserName"
};

export const TestConfigurationFieldNames = {
    ConfigurationSK: "TestConfigurationSK",
    ConfigurationId: "TestConfigurationId",
    ConfigurationName: "Name"
};

export const TestSuiteFieldNames = {
    PlanId: "TestPlanId",
    PlanTitle: "TestPlanTitle",
    IdLevel1: "IdLevel1",
    IdLevel2: "IdLevel2",
    IdLevel3: "IdLevel3",
    TitleLevel1: "TitleLevel1",
    TitleLevel2: "TitleLevel2",
    TitleLevel3: "TitleLevel3"
};

export const TestProgressFilterFields = {
    Priority: "priority",
    TestPlan: "testplan",
    TestSuite: "testsuite",
    Configuration: "configuration",
    AssignedTo: "assignedto",
    Tester: "tester",
    Outcome: "outcome"
};

export const TestPointHistorySnapshotFieldNames = {
    PlanId: "TestPlanId",
    ConfigurationId: "TestConfigurationId",
    Priority: "Priority",
    ResultOutcome: "ResultOutcome",
    DateSK: "DateSK"
};

export const TestProgressReportWidgetNames = {
    DetailsWidget: "DetailsWidget",
    OverallStateWidget: "OverallStateWidget",
    PointHistoryWidget: "PointHistoryWidget"
};

export const AssetPath = {
    NoTestPlansImagePath: "ms.vss-test-analytics-web/test-progress-reports-assets/zero-testplans.png"
};

export const OutcomeConstants = {
    Passed: "Passed",
    Failed: "Failed",
    Blocked: "Blocked",
    NotApplicable: "NotApplicable",
    NotRun: "None",
    Other: "Other"
};

export const OutcomeToColorMap = {
    NotExecuted: "#A6A6A6",
    Passed: "#269624",
    Failed: "#B31B1B",
    Blocked: "#004378",
    NotApplicable: "#E76D00",
    Other: "#DEDEDE"
};
